module.exports = __webpack_public_path__ + "img/detail1.de1634fc.png";